import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=2b4f51fa&"
import script from "./questionList.vue?vue&type=script&lang=js&"
export * from "./questionList.vue?vue&type=script&lang=js&"
import style0 from "./questionList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports